export default "__VITE_ASSET__CvlpBYre__"